/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "apiActions",
            "endpoint": "https://9acf9mckj6.execute-api.us-west-2.amazonaws.com/master",
            "region": "us-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://7glbz2ofr5bv7eewzm5pqqt2gu.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-d4baatgupnhozbcviuoqbgasju",
    "aws_cognito_identity_pool_id": "us-west-2:47ef0f1f-c75e-457b-b0fa-3b7cd6d141ab",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_XtdIazuYQ",
    "aws_user_pools_web_client_id": "2ag8v8qceg3sp4fqj9jimllafk",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
